import { Outlet } from "react-router-dom";
import useAuthGuard from "../hooks/useAuthGuard";

const ProtectedRoute = () => {
  useAuthGuard();
  return <Outlet />;
};

export default ProtectedRoute;
